import { __assign } from "tslib";
import { EndpointCache } from "@aws-sdk/endpoint-cache";
export var resolveEndpointDiscoveryConfig = function resolveEndpointDiscoveryConfig(input, _a) {
  var _b;

  var endpointDiscoveryCommandCtor = _a.endpointDiscoveryCommandCtor;
  return __assign(__assign({}, input), {
    endpointDiscoveryCommandCtor: endpointDiscoveryCommandCtor,
    endpointCache: new EndpointCache((_b = input.endpointCacheSize) !== null && _b !== void 0 ? _b : 1000),
    endpointDiscoveryEnabled: input.endpointDiscoveryEnabled !== undefined ? function () {
      return Promise.resolve(input.endpointDiscoveryEnabled);
    } : input.endpointDiscoveryEnabledProvider,
    isClientEndpointDiscoveryEnabled: input.endpointDiscoveryEnabled !== undefined
  });
};